import React from "react";
import styled from "styled-components";
import { SingularAvatar } from "@sonder/ui/source/styled/fragments/MultiAvatar";
import { Cell } from "@sonder/ui/source/styled/fragments/Table";
import { borders } from "@sonder/ui/source/styled/theme";
import { MetricData, MetricRowData } from "core/queries/GetBuildingsMetrics";
import { useAppSelector } from "core/store";
import { ReportType } from "reports/slice";

const StyledAvatar = styled(SingularAvatar)`
  margin-inline-end: 0.8571rem;
`;

const StyledCell = styled(Cell)`
  border-left: ${borders.standard};
  justify-content: flex-end;
  padding-right: 1.143rem;
`;

interface ReportRowProps {
  metricRow: MetricRowData;
}

export const ReportsRow = ({ metricRow }: ReportRowProps) => {
  const reportType = useAppSelector(state => state.reports.reportType);

  const { metrics, resource } = metricRow;

  const renderResource = () => {
    switch (reportType) {
      case ReportType.Buildings:
        return resource.name;
      case ReportType.Individuals:
        return (
          <>
            <StyledAvatar imageUrl={resource.imageUrl} name={resource.name} />
            <div>{resource.name}</div>
          </>
        );
      default:
        return "N/A";
    }
  };

  const renderMetric = (metric: MetricData, index: number) => {
    const { formattedValue } = metric;
    return <StyledCell key={index}>{formattedValue}</StyledCell>;
  };

  return (
    <>
      <Cell>{renderResource()}</Cell>
      {metrics.map(renderMetric)}
    </>
  );
};
